import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
const mediaQuery40 = [{ screen: '(min-width: 280px)', width: '40px' }]
const mediaQuery50 = [{ screen: '(min-width: 280px)', width: '50px' }]
const mediaQuery60 = [{ screen: '(min-width: 280px)', width: '60px' }]

export default function ToolTip() {
  const { t } = useTranslation('homebase')

  return (
    <div
      className="flex flex-col justify-center absolute left-4 top-20 md:top-16 md:left-14 bg-white text-black-light z-50 rounded w-72"
      style={{ boxShadow: 'rgba(0, 0, 0, 0.3) -2px 5px 12px' }}
    >
      <div className="flex">
        <div className="flex justify-center bg-purple py-3 px-1.5 rounded-tl w-full max-w-16">
          <span className="max-h-16">
            <ResponsiveImage
              height={40}
              imageWidths="40"
              mediaQuery={mediaQuery40}
              srcKey="icons/products/video-crash-course.png"
              width={40}
            />
          </span>
        </div>
        <div className="p-2">
          <h4 className="text-sm font-semibold">{t('tooltip.videoCourse')}</h4>
          <p className="text-xs">{t('tooltip.description.videoCourse')}</p>
        </div>
      </div>
      <div className="flex">
        <div className="flex justify-center bg-purple py-3 px-1.5 w-full max-w-16">
          <span className="max-h-16">
            <ResponsiveImage
              height={40}
              imageWidths="50"
              mediaQuery={mediaQuery50}
              srcKey="icons/products/encyclopedia-v2.png"
              width={50}
            />
          </span>
        </div>
        <div className="p-2">
          <h4 className="text-sm font-semibold">{t('tooltip.encylopedia')}</h4>
          <p className="text-xs">{t('tooltip.description.encylopedia')}</p>
        </div>
      </div>
      <div className="flex">
        <div className="flex justify-center bg-purple py-3 px-1.5 rounded-bl w-full max-w-16">
          <span className="max-h-16">
            <ResponsiveImage
              height={40}
              imageWidths="60"
              mediaQuery={mediaQuery60}
              srcKey="icons/products/math-essentials.png"
              width={60}
            />
          </span>
        </div>
        <div className="p-2">
          <h4 className="text-sm font-semibold">{t('tooltip.mathEssential')}</h4>
          <p className="text-xs">{t('tooltip.description.mathEssential')}</p>
        </div>
      </div>
    </div>
  )
}
